module.exports = __webpack_public_path__ + "img/2026-2.2ab6ab01.jpg";